export {
  initialize,
  isInitialized,
  openSession,
  automaticallyShowInAppMessages,
  changeUser,
  isPushSupported,
  requestPushPermission,
  requestImmediateDataFlush,
  getUser,
  wipeData,
  // logCustomEvent / logPurchase were previously missing here, so
  // brazeAdapter's primary branch (`braze.logCustomEvent`) was always
  // undefined and every event silently fell through to a duplicate
  // `import('@braze/web-sdk')` fallback. Re-exported so the adapter uses this
  // single shared module for everything, as its own comment always claimed.
  logCustomEvent,
  logPurchase,
} from '@braze/web-sdk';
